
<div class="row">
  <div class="col-9 col-12-narrower"> 
    <!-- Content -->
    <article id="content">
      <app-feature id={{this.id}}></app-feature>
    </article>
  </div>
  <div class="col-3 col-12-narrower"> 
    
    <!-- Sidebar -->
    <div class="feature">
      <app-full-list></app-full-list>
    </div>
  </div>
</div>
